// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__-8p_v","btn":"styles_btn__3UiDL"};